import React from 'react'
import styled from 'styled-components'
import { Box, Text } from 'grommet'

const TypeText = styled(Text)`
  background-color: ${props => props.theme.global.colors[props.typeColor]};
  width: 5rem;
  font-size: 1.4rem;
  text-align: center;
  border-radius: 2rem;
`

const IndexText = styled(Text)`
  width: 5rem;
`

const NameText = styled(Text)`
  flex: 1;
  text-align: center;
`

const Container = styled(Box)`
  flex: 1;
  &::-webkit-scrollbar {
    width: 5px !important;
  }
  &::-webkit-scrollbar-track {
    background: ${props =>
      props.theme.global.colors.darkBgScrollTrack} !important;
  }
  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${props =>
      props.theme.global.colors.darkBgScrollThumb} !important;
  }
  padding-right: 1rem;
  padding-left: 1rem;
`

const ItemBox = styled(Box)`
  flex-shrink: 0;
`

// const groupBy = (data, key) => {
//   // `data` is an array of objects, `key` is the key (or property accessor) to group by
//   // reduce runs this anonymous function on each element of `data` (the `item` parameter,
//   // returning the `storage` parameter at the end
//   return data.reduce(function(storage, item) {
//     // get the first instance of the key by which we're grouping
//     var group = item[key]

//     // set `storage` for this instance of group to the outer scope (if not empty) or initialize it
//     storage[group] = storage[group] || []

//     // add this item to its group within `storage`
//     storage[group].push(item)

//     // return the updated storage to the reduce function, which will then loop through the next
//     return storage
//   }, {}) // {} is the initial value of the storage
// }

const Score = ({ choices }) => {
  const addArray = choices.filter(item => item.count > 0)

  if (addArray.length > 0) {
    addArray.sort((a, b) => b.count - a.count)
  } else {
    return (
      <Box flex={true}>
        <Text textAlign="center" size="1.6rem">
          This section shows all the accumulated counts of choices if have any.
        </Text>
      </Box>
    )
  }
  //   const addObjects = groupBy(addArray, 'name')
  //   const addObjectsKeys = Object.keys(addObjects)

  return (
    <Container
      gap=".5rem"
      overflow={{ horizontal: 'hidden', vertical: 'auto' }}
    >
      {addArray.map((item, index) => {
        return (
          <ItemBox
            direction="row"
            key={`addArray${index}`}
            justify="between"
            height="2.4rem"
          >
            <IndexText>{index + 1}.</IndexText>
            <NameText truncate>{item.name}</NameText>
            <TypeText typeColor="primary" color="white">
              +{item.count}
            </TypeText>
          </ItemBox>
        )
      })}
    </Container>
  )
}

export default Score
